// extracted by mini-css-extract-plugin
module.exports = {"root":"StaticTextPage__root--2B5rm","summary":"StaticTextPage__summary--H5eIv Page__section--3YChj"};